module.exports = __webpack_public_path__ + "static/feature-media-a2a213b1cd343f808b0348b461abb5e1.png";